import React from "react";

const UI = {
  spacing: { xs: 6, sm: 8, md: 12, lg: 16, xl: 24 },
  radius:  { sm: 6, md: 8, lg: 12 },
  colors: {
    primary:   "#0F172A",
    secondary: "#334155",
    muted:     "#64748B",
    subtle:    "#94A3B8",
    border:    "#E2E8F0",
    bg:        "#F8FAFC",
    white:     "#FFFFFF"
  }
};

const JobBulkActionBar = ({ selectedCount, onMarkComplete, onCancelJobs, onExport, onClear }) => {
  if (selectedCount === 0) return null;
  
  return (
    <div style={{
      background: UI.colors.primary,
      borderRadius: UI.radius.md,
      padding: "8px 14px",
      marginBottom: UI.spacing.lg,
      display: "flex",
      alignItems: "center",
      gap: UI.spacing.md,
      flexWrap: "wrap",
      animation: "fadeIn 0.15s ease"
    }}>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      
      <span style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontSize: 13,
        fontWeight: 600,
        color: UI.colors.white
      }}>
        {selectedCount} job{selectedCount !== 1 ? 's' : ''} selected
      </span>
      
      <div style={{
        width: 1,
        height: 20,
        background: "rgba(255,255,255,0.15)"
      }} />
      
      <button
        onClick={onMarkComplete}
        style={{
          background: "transparent",
          border: `1px solid rgba(255,255,255,0.15)`,
          borderRadius: 6,
          padding: "5px 12px",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontSize: 12,
          fontWeight: 600,
          color: UI.colors.white,
          cursor: "pointer"
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}
        onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
      >
        Mark Completed
      </button>
      
      <button
        onClick={onCancelJobs}
        style={{
          background: "transparent",
          border: `1px solid rgba(255,255,255,0.15)`,
          borderRadius: 6,
          padding: "5px 12px",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontSize: 12,
          fontWeight: 600,
          color: "#FCA5A5",
          cursor: "pointer"
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}
        onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
      >
        Cancel Jobs
      </button>
      
      <button
        onClick={onExport}
        style={{
          background: "transparent",
          border: `1px solid rgba(255,255,255,0.15)`,
          borderRadius: 6,
          padding: "5px 12px",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontSize: 12,
          fontWeight: 600,
          color: "#A5B4FC",
          cursor: "pointer"
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}
        onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
      >
        Export CSV
      </button>
      
      <button
        onClick={onClear}
        style={{
          background: "transparent",
          border: "none",
          fontSize: 16,
          color: "rgba(255,255,255,0.5)",
          cursor: "pointer",
          marginLeft: "auto"
        }}
        onMouseEnter={(e) => e.currentTarget.style.color = "rgba(255,255,255,0.8)"}
        onMouseLeave={(e) => e.currentTarget.style.color = "rgba(255,255,255,0.5)"}
      >
        ✕
      </button>
    </div>
  );
};

export default JobBulkActionBar;